import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import ReactDatePicker from 'react-datepicker';
import { parse, isValid } from "date-fns";

import {WithCommonTranslations} from '../hocs';
import {TranslationMixin} from 'mixins';

import {Validators} from 'services';

import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.css';

export const DatePicker = WithCommonTranslations(
    class extends TranslationMixin(React.Component) {
      constructor(props) {
        super(props);

        this.state = {
          error: '',
          errorMsg: '',
        };

        this.inputRef = React.createRef();
        this.handleBlur = this.handleBlur.bind(this);
      }

      componentDidMount() {
        this.setErrorState(this.getInput(this.inputRef));
      }

      componentDidUpdate(prevProps) {
        if (prevProps.selected !== this.props.selected ||
            prevProps.required !== this.props.required ||
            this.props.customError !== prevProps.customError ||
            prevProps.readOnly !== this.props.readOnly) {
          this.setErrorState(this.getInput(this.inputRef));
        }
      }

      handleBlur(e) {
        if (!this.props.readOnly) {
          let date = this.checkValidity(e.target.value);
          this.setErrorState(this.getInput(this.inputRef));
          this.props.onChange(date);
        }
      }

      checkValidity(date) {
        //TODO hardcoded to en-US locale format, should be locale-specific
        let isValidDate = true;
        let parsedDate = null;
        if (date !== '') {
          let formats = ['M/d/yyyy'];
          if (this.props.dateFormat) {
            formats.push(this.props.dateFormat);
          }
          for (let format of formats) {
            parsedDate = parse(date, format, new Date());
            if (isValid(parsedDate)) {
              isValidDate = true;
              break;
            } else {
              isValidDate = false;
            }
          }
        }
        let input = this.getInput(this.inputRef);

        let errorMsg = '';
        if (isValidDate) {
          //don't clear out custom error message
          if (input.validity.customError) {
            errorMsg = input.validationMessage;
          }
        } else {
          errorMsg = this.props.invalidDateMsg;
        }

        input.setCustomValidity(errorMsg);
        if(isValidDate){
          return parsedDate;
        } else {
          return null;
        }
      }

      setErrorState(input) {
        let errorMsg = Validators.getValidityMessage(input);

        this.setState({
          errorMessage: errorMsg,
          error: errorMsg ? true : false,
        });
      }

      getInput(ref) {
        const dom = ReactDOM.findDOMNode(ref.current);
        return dom.querySelector('input');
      }

      render() {
        let {label, id, readOnly, displayError, ...otherProps} = this.props;
        let showError = displayError &&
            (this.state.error || this.props.customError);

        return (
            <div className={'tds-datepicker' +
            (showError ? ' tds-datepicker-error' : '')}>
              {label && <label htmlFor={id}>{label}
                {this.props.required &&
                <span className="asterisk">*</span>}</label>}
              <ReactDatePicker id={id}
                               disabled={readOnly}
                               ref={this.inputRef}
                               onBlur={this.handleBlur}
                               {...otherProps}/>
              {showError &&
              <span className="errorMsg">
            {this.getTranslation(this.state.errorMessage,
                this.state.errorMessage) || this.props.customError}</span>}
            </div>
        );
      }
    });

DatePicker.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  invalidDateMsg: PropTypes.string.isRequired,
  displayError: PropTypes.bool.isRequired,
  customError: PropTypes.string,
};